import React from 'react';
import useSortStore from '../store/useSortStore';
import { SortDirection } from '../types/filterAndSort';
/**
 * Copies functionality in fyh
 */
const SortDirectionToggle = () => {
    const { sortDirection, setSortDirection } = useSortStore();
    const onDirectionClick = (event) => {
        if (sortDirection === SortDirection.Ascending) {
            setSortDirection(SortDirection.Descending);
        }
        else {
            setSortDirection(SortDirection.Ascending);
        }
    };
    return (React.createElement("div", { className: "sort-direction-toggle__container" },
        React.createElement("button", { className: 'sort-direction-toggle' + (sortDirection === SortDirection.Ascending ? ' ascending' : ''), onClick: onDirectionClick },
            React.createElement("span", { className: "sr-only" }, "Sort Order")),
        React.createElement("span", { className: "sr-only", "aria-live": "assertive" },
            "Results Sorted in ",
            sortDirection === SortDirection.Ascending ? 'Ascending' : 'Descending',
            " Order")));
};
export default SortDirectionToggle;
